const hostnames = ['localhost', '127.0.0.1'];
const ENV_SHARED = {
    REACT_APP_RECO_EXTERNAL_API_URL: '/zootopia-recommender/api',
    isLocalhost: !!window?.location?.hostname && hostnames.includes(window.location.hostname),
};
const ENV_DEVELOPMENT = {
    ...ENV_SHARED,
    stage: 'dev',
    isDev: true,
};
const ENV_PRODUCTION = {
    ...ENV_SHARED,
    stage: 'prod',
    isDev: false,
};
const ENV = process.env.STAGE === 'dev' ? ENV_DEVELOPMENT : ENV_PRODUCTION;

export { ENV };
//# sourceMappingURL=environment.js.map
